module.exports = __webpack_public_path__ + "img/out-there-screaming-an-anthology-of-new-black-horror.53016cc9.png";